"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var v2_1 = require("./v2");
var shortcode_1 = require("./shortcode");
var APIVersion;
(function (APIVersion) {
    APIVersion[APIVersion["v1"] = 1] = "v1";
    APIVersion[APIVersion["v2"] = 2] = "v2";
    APIVersion[APIVersion["v3"] = 3] = "v3";
})(APIVersion = exports.APIVersion || (exports.APIVersion = {}));
;
var Action;
(function (Action) {
    Action["ChangedFeature"] = "changed_feature";
    Action["AddedAccessory"] = "added_accessory";
    Action["RemovedAccessory"] = "removed_accessory";
})(Action = exports.Action || (exports.Action = {}));
;
exports.ZL_ACCESSORIES = "ZL_ACCESSORIES";
exports.ZL_OPTIONS = "ZL_OPTIONS";
exports.processLogic = function (codes, logic) {
    if (!logic) {
        return false;
    }
    var anylogic = logic;
    if (anylogic.not) {
        return !exports.processLogic(codes, anylogic.not);
    }
    else if (anylogic.xor) {
        return anylogic.xor.reduce(function (count, l) { return count + (exports.processLogic(codes, l) ? 0 : 1); }, 0) === 1;
    }
    else if (anylogic.or) {
        return anylogic.or.some(function (l) { return exports.processLogic(codes, l); });
    }
    else if (anylogic.and) {
        return anylogic.and.every(function (l) { return exports.processLogic(codes, l); });
    }
    if (typeof (logic) === "string") {
        return codes.map(function (c) { return c.toLowerCase(); }).includes(logic.toLowerCase());
    }
    return true;
};
exports.formatPrice = function (price, locale, negate) {
    if (!price || !price.currency) {
        return undefined;
    }
    var currency = price.currency;
    //Workaround for dodgy browser handling of Norwegian Krone [BRPLA-78]
    if (price.currency === "NOK") {
        currency = "SEK";
        locale = "sv-SE";
    }
    try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format((negate ? -1 : 1) * price.amount);
    }
    catch (_a) {
        console.error("Failed to format price", { price: price, locale: locale, currency: currency });
    }
    return undefined;
};
var users = {};
function _getSession(userId) {
    if (users[userId] !== undefined) {
        if (users[userId].session) {
            return users[userId].session;
        }
    }
    return null;
}
function StartSession(version, userId, server, brand, locale, region, currency, zlservice) {
    if (zlservice === void 0) { zlservice = "stage"; }
    switch (version) {
        default:
            users[userId] = { id: userId, session: new v2_1.SessionV2(userId, server, brand, locale.slice(3), locale, region, currency, zlservice), builds: [] };
            break;
    }
    return users[userId].session.id;
}
exports.StartSession = StartSession;
function GetUser(userId) {
    return users[userId];
}
exports.GetUser = GetUser;
function GetBuilds(userId) {
    var _this = this;
    return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
        var session, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    session = _getSession(userId);
                    if (!session) return [3 /*break*/, 2];
                    _a = users[userId];
                    return [4 /*yield*/, session.requestBuilds()];
                case 1:
                    _a.builds = _b.sent();
                    resolve(users[userId].builds);
                    return [3 /*break*/, 3];
                case 2:
                    reject("Was unable to request builds - no active session for " + userId);
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); });
}
exports.GetBuilds = GetBuilds;
function StartBuildSession(userId, buildId, onBuildSessionUpdate, onConflict, onAttachChoice, onShortCode, initialData, shortcode, testDataSource) {
    var _this = this;
    return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
        var user, build, data, buildSession, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    user = users[userId];
                    if (!(user && user.session)) return [3 /*break*/, 10];
                    build = undefined;
                    if (!shortcode) return [3 /*break*/, 2];
                    return [4 /*yield*/, shortcode_1.load(shortcode, user.session.zlservice)];
                case 1:
                    build = (_a.sent()).state;
                    if (!build) {
                        reject("Failed to load shortcode");
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    build = user.builds.find(function (b) { return b.uuid === buildId; });
                    _a.label = 3;
                case 3:
                    if (build) {
                        initialData = build;
                        /* shouldn't need this if we match up the naming conventions but right now the
                        field names we store don't match what we're using here for setup. */
                        if (!initialData.packageId && build.package) {
                            initialData.packageId = build.package;
                        }
                        if (!initialData.platformId && build.model) {
                            initialData.platformId = build.model;
                        }
                        if (!initialData.modelYear && build.year) {
                            initialData.modelYear = build.year;
                        }
                        /* ------------------------------------------------------------------------------- */
                    }
                    if (!initialData) return [3 /*break*/, 9];
                    data = {};
                    buildSession = null;
                    switch (user.session.version) {
                        case APIVersion.v2:
                            data = {
                                buildId: buildId,
                                model: initialData.platformId,
                                pkg: initialData.packageId,
                                year: initialData.modelYear,
                                unitsku: initialData.unitId,
                                requiredFeatures: initialData.requiredFeatures,
                                desiredFeatures: initialData.desiredFeatures,
                                desiredAccessories: initialData.desiredAccessories
                            };
                            buildSession = new v2_1.BuildSessionV2(user.session, {}, build || {}, onBuildSessionUpdate, onConflict, onAttachChoice, onShortCode, undefined, undefined, undefined, true, shortcode);
                            break;
                    }
                    if (!buildSession) return [3 /*break*/, 8];
                    _a.label = 4;
                case 4:
                    _a.trys.push([4, 7, , 8]);
                    if (!onBuildSessionUpdate) return [3 /*break*/, 6];
                    return [4 /*yield*/, buildSession.start(data, testDataSource)];
                case 5:
                    buildSession = _a.sent();
                    _a.label = 6;
                case 6:
                    resolve(buildSession);
                    return [2 /*return*/];
                case 7:
                    err_1 = _a.sent();
                    reject(err_1);
                    return [2 /*return*/];
                case 8:
                    reject("Failed to create build session");
                    return [2 /*return*/];
                case 9:
                    reject("Missing initialisation data");
                    return [2 /*return*/];
                case 10:
                    reject("Session not found");
                    return [2 /*return*/];
            }
        });
    }); });
}
exports.StartBuildSession = StartBuildSession;
//# sourceMappingURL=api.js.map